module.exports = __webpack_public_path__ + "img/nossojeito_esquerdo.690af020.png";